import { PlanCategory } from '@/shared/types/Billing';

export type PricingCardFeatureItem = {
  label: string;
  badge?: string;
  highlighted?: boolean;
};

type PricingCardFeature = {
  everythingIn: string;
  features: PricingCardFeatureItem[];
};

const text = (label: string): PricingCardFeatureItem => ({ label });

export const PRICING_CARD_FEATURES: Record<PlanCategory, PricingCardFeature> = {
  business: {
    everythingIn: 'Everything in Creator Pro, plus:',
    features: [
      text('Ensure brand voice consistency'),
      text('Control terminology in translation'),
      text('Process volumes faster than ever'),
    ],
  },
  creator: {
    everythingIn: '',
    features: [
      text('Dub in 135+ languages with AI'),
      text('Clone voices in 32 languages'),
      text('Powerful unlimited editor'),
      text('Auto transcription and translation'),
    ],
  },
  creator_pro: {
    everythingIn: 'Everything in Creator, plus:',
    features: [
      { label: 'Add lip-sync and subtitles', badge: 'Included', highlighted: true },
      text('Use pro-level voice and script tools'),
      text('Work together in shared space'),
    ],
  },
  enterprise: {
    everythingIn: 'Everything in Business, plus:',
    features: [
      text('Get custom contracts and invoicing'),
      text('Access dedicated priority support'),
      text('Tailor everything to fit your needs'),
    ],
  },
  starter: {
    everythingIn: '',
    features: [],
  },
};
